(() => {
  const callback = () => {
    const triggers = document.querySelectorAll('[data-tooltip-content], [data-tooltip-element]');

    triggers.forEach((trigger) => {
      // Attach the tooltip to an icon inside the trigger element if possible
      const icon = trigger.querySelector('svg');
      const element = icon || trigger;

      const { tooltipContent, tooltipElement, tooltipPlacement, tooltipMaxWidth } = trigger.dataset ?? {};
      const tooltipReferenceElement = document.querySelector(tooltipElement);
      const content = tooltipContent || tooltipReferenceElement;

      // Skip already initialized and empty tooltips
      if (element._tippy || !content) return;

      tippy(element, {
        theme: 'light',
        animation: 'shift-away-subtle',
        content,
        placement: tooltipPlacement || 'top',
        triggerTarget: trigger,
        maxWidth: Number(tooltipMaxWidth) || 250,
        allowHTML: true,
      });
    });

    document.addEventListener('tooltips:init', callback);
  };
  window.addEventListener('DOMContentLoaded', callback);
})();
